import sdl from '@jds/react-generated-sdl/JDSInputCodeItem';
import type { JDSInputCodeItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSInputCodeItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    secureText = false,
    state = 'undefined',
    disabled = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { secureText, state, disabled, ...rest },
    'JDSInputCodeItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputCodeItem = withLogic(
  Component
) as React.FC<JDSInputCodeItemProps> & { slotName?: string };

InputCodeItem.displayName = 'InputCodeItem';
InputCodeItem.slotName = 'jds_input_code_item';

export { InputCodeItem, type JDSInputCodeItemProps };
